<template>
<v-dialog
      v-if="selection"
      :value="selection"
      max-width="800"
    >
      <v-card>
        <v-img
              :src="selection['related_property.public_url_string']"
              class="white--text align-end mb-6"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              style="background-color:#333333"
              height="300px"
              
            >
            
              <v-card-title v-text="selection.Sub_Project_Work_Name_SPW"></v-card-title>
              
            </v-img>
       
        
        <v-card-text>

          <v-select v-model="selection.Schedule_SPW" :items="['Not Started','In Progress','Ready to Review','Complete']" filled outlined dense label="Status"></v-select>      

          <v-autocomplete
                v-model="selection.Foreman_SPW"
                :items="users"
                color="white"
                hide-selected
                item-text="Name_Concatenate"
                item-value="ID"
                hide-details
                return-object
                dense
                filled
                outlined
                class="mb-6"
                label="Select Foreman"
                elevation="0"
                > 
                </v-autocomplete>

                <v-autocomplete
                    v-model="selection.Department_in_Charge_SPW"
                    :items="departments"
                    color="white"
                    hide-selected
                    item-text="Department_Name"
                    item-value="ID"
                    hide-details
                    return-object
                    filled
                    outlined
                    dense
                    class="mb-6 pa-0"
                    label="Select Department"
                    elevation="0"

                    > 
                    </v-autocomplete>

        <div class="d-flex" style="column-gap:20px;">
        <div class="mb-4" style="flex:1">  
                <DateSelect :bindTo="selection.Start_Date_SPW" :callback="updateStartDate" :label="'Start Date'" filled ></DateSelect>
        </div>
              
        <div class="mb-4" style="flex:1">  
                <DateSelect :bindTo="selection.End_Date_SPW" :callback="updateEndDate" :label="'End Date'" filled></DateSelect>
                </div>
        </div>   

        </v-card-text>
 <v-divider></v-divider>
 <v-card-actions>
  
          <v-spacer></v-spacer>
          
          <v-btn class="mr-2" small dark :href="`https://app.zohocreator.com/danehansen/wc-projects/#Form:Create_Property?recLinkID=${selection.related_property.ID}&viewLinkName=Properties`" target="_blank"><v-icon class="mr-1">home</v-icon>Property</v-btn>
          <v-btn class="mr-2" small dark :href="selection['Sub_Project_SPW.Link_To_Overview']" target="_blank"><v-icon class="mr-1">launch</v-icon>View in Zoho</v-btn>
          <v-btn
            
            text
            @click="selection=undefined"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>



<script>
import { mapFields } from 'vuex-map-fields';
import DateSelect from './DateSelect';

  export default {
    data: () => ({
        
    }),
    components: {

DateSelect

    },
    computed:{
        ...mapFields(['selection','users','departments'])
    },
    mounted() {
        console.log(this.selection)

    },
    beforeDestroy(){
     
    },
    methods: {
    updateStartDate(evt){
          this.selection.Start_Date_SPW = evt
      },
      updateEndDate(evt){
          this.selection.End_Date_SPW = evt
      },
    }
  }
</script>

<style>
</style>